export default __webpack_public_path__ + "static/media/icon_down.b10c14b2.svg";